import React, { useState } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  DevDashboardWrapper,
  DashboardContainer,
  BurgerButton,
  SidebarOverlay,
  Sidebar,
  SidebarTop,
  SidebarLogoLink,
  SidebarLogoSJ,
  SidebarLogoMate,
  SidebarTitle,
  SidebarDivider,
  NavList,
  NavItem,
  SidebarBottom,
  LogoutButton,
  MainContent,
} from './styles';
const navSections = [
  { id: 'overview', label: 'Overview', path: '/dev' },
  { id: 'users', label: 'Users', path: '/dev/users' },
  { id: 'coaches', label: 'Coaches', path: '/dev/coaches' },
  { id: 'athletes', label: 'Athletes', path: '/dev/athletes' },
  { id: 'subscriptions', label: 'Subscriptions', path: '/dev/subscriptions' },
];

export default function DevDashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const pathname = location.pathname.replace(/\/$/, '') || '/dev';
  const activeSection = navSections.find(
    (s) => pathname === s.path || (s.path !== '/dev' && pathname.startsWith(s.path))
  );
  const activeId = activeSection?.id ?? 'overview';

  const handleNav = (path: string) => {
    navigate(path);
    setIsSidebarOpen(false);
  };

  const handleLogout = () => {
    logout();
    navigate('/signin');
  };

  return (
    <DevDashboardWrapper className="dev-dashboard">
      <DashboardContainer>
        <BurgerButton
          type="button"
          $isOpen={isSidebarOpen}
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </BurgerButton>
        <SidebarOverlay $isOpen={isSidebarOpen} onClick={() => setIsSidebarOpen(false)} aria-hidden="true" />
        <Sidebar $isOpen={isSidebarOpen}>
          <SidebarTop>
            <SidebarLogoLink to="/" aria-label="Go to welcome page">
              <SidebarLogoSJ>sj</SidebarLogoSJ>
              <SidebarLogoMate>Mate</SidebarLogoMate>
            </SidebarLogoLink>
            <SidebarTitle>DEV DASHBOARD</SidebarTitle>
            <SidebarDivider />
          </SidebarTop>
          <NavList>
            {navSections.map((section) => (
              <NavItem
                key={section.id}
                type="button"
                $active={activeId === section.id}
                onClick={() => handleNav(section.path)}
              >
                {section.label}
              </NavItem>
            ))}
          </NavList>
          <SidebarBottom>
            <LogoutButton type="button" onClick={handleLogout}>
              Logout
            </LogoutButton>
          </SidebarBottom>
        </Sidebar>
        <MainContent>
          <Outlet />
        </MainContent>
      </DashboardContainer>
    </DevDashboardWrapper>
  );
}
